<template>
  <div class="menu">
    <div class="logo">
      <img
        src="/ytys@2x.png"
        width="110px"
        @click="$router.replace({ path: '/' })" />
    </div>
    <div class="menu-box">
      <div
        class="active-bar"
        :style="{
          width: `${menu?.clientWidth}px`,
          transform: `translateX(${menu?.offsetLeft}px)`,
        }"></div>
      <template v-for="(menu, index) in menus">
        <el-popover
          v-if="!menu.meta?.hide && menu.children"
          transition="el-zoom-in-top"
          :offset="-5"
          :popper-style="{
            padding: '8px 0',
            '--el-popover-border-radius': '10px',
          }"
          :persistent="false"
          trigger="hover">
          <template #reference>
            <div
              class="menu-item"
              :active="index === active"
              @click="jump(menu.path, menu.name, menu.meta?.query)">
              <div class="name" ref="menusRef">
                {{ menu.meta?.name }}
              </div>
            </div>
          </template>
          <template v-for="item in menu.children">
            <div
              v-if="!item.meta?.hide"
              class="option"
              @click="jump(item.path, item.name, item.meta?.query)">
              {{ item.meta?.name }}
            </div>
          </template>
        </el-popover>
        <template v-else>
          <div
            v-if="!menu.meta?.hide"
            class="menu-item"
            :active="index === active"
            @click="jump(menu.path, menu.name, menu.meta?.query)">
            <div ref="menusRef" class="name" v-if="menu.meta?.custom">
              <el-popover placement="bottom" :width="400" trigger="hover">
                <template #reference>
                  <span>{{ menu.name }}</span>
                </template>
              </el-popover>
            </div>
            <div class="name" ref="menusRef" v-else>
              {{ menu.name }}
              <div class="badge" v-if="menu.name == '课程资料'">免费1V1</div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import {
  useRoute,
  useRouter,
  onBeforeRouteUpdate,
  type RouteRecordName,
} from "vue-router";
import { menus } from "@/router";
import { useUserStore } from "@/store/user.store";
const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const emits = defineEmits(["login"]);
const active = ref(0);
const menusRef = ref([]);
const menu = ref({
  clientWidth: 0,
  offsetLeft: 20,
});

const jump = (path: string, name?: RouteRecordName, type?: number) => {
  if (path) {
    if (path.startsWith("http")) {
      console.log("window.location:" + window.location.host);

      if (path == "https://kt.ytaxx.com") {
        const token = window.localStorage.getItem("token");
        userStore.userInfo;
        // if (window.location.host === "dev.winielts.com") {
        // path = "https://test-ke.ytaxx.com";
        // }
        if (token && userStore.userInfo) {
          path = `${path}?mobileToken=${userStore.userInfo.mobileToken?.token}`;
        }
      }
      window.open(path);
    } else {
      router.push({ name: name, query: { type } });
    }
  } else {
    router.push({ name: name, query: { type } });
  }
};

const update = (val = route) => {
  active.value = menus.findIndex((menu) => {
    if (
      (menu.path.length > 0 && val.fullPath.startsWith("/" + menu.path)) ||
      val.meta.name === menu.name
    ) {
      return true;
    } else {
      return menu.children?.some((item) => {
        return val.meta.name === item.meta?.name;
      });
    }
  });
  if (menusRef.value[active.value]) {
    menu.value = menusRef.value[active.value];
  } else {
    menu.value = { clientWidth: 0, offsetLeft: 0 };
  }
};

const opLogo = () => {
  window.open("https://www.yangtuoedu.com/");
};

onMounted(() => {
  update();
});
onBeforeRouteUpdate(update);
</script>

<style lang="less" scoped>
.menu {
  display: flex;
  height: 100%;

  .logo {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }

  .menu-box {
    display: flex;
    position: relative;

    .menu-item[active="true"] {
      color: var(--el-color-primary);
    }

    .menu-item:hover {
      color: var(--el-color-primary);
    }

    .menu-item {
      padding: 0 20px;
      transition: color var(--el-transition-duration);
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .name {
        position: relative;
      }

      .badge {
        user-select: none;
        position: absolute;
        width: max-content;
        padding: 0 2px;
        box-sizing: border-box;
        background: linear-gradient(154deg, #9f82ff 0%, #e19aff 100%);
        border-radius: 8px;
        font-weight: bold;
        font-size: 11px;
        color: #ffffff;
        top: -15px;
        right: -15px;
      }
    }

    .active-bar {
      position: absolute;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background-color: var(--el-color-primary);
      z-index: 1;
      transition: width var(--el-transition-duration)
          var(--el-transition-function-ease-in-out-bezier),
        transform var(--el-transition-duration)
          var(--el-transition-function-ease-in-out-bezier);
      list-style: none;
    }
  }
}
</style>
<style lang="less">
.q-box {
  display: flex;

  .q-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .q-name {
      width: 100%;
      border-bottom: 2px solid #f6f6f6;
      text-align: center;
      font-size: 16px;
      color: #999999;
      padding-bottom: 15px;
      margin-bottom: 12.5px;

      &.active {
        color: var(--el-color-primary);
        font-weight: bold;
      }
    }

    .q-item {
      padding: 7.5px 0;
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #000000;
      cursor: pointer;

      &:hover {
        background-color: var(--el-fill-color-light);
        border-radius: 8px;
      }
    }
  }
}
</style>
